import axios from "./axios"
import { save } from "../helpers/localStorage"

export default {
  createEmployee: async ({ email, full_name, employee_role }) => {
    try {
      const result = await axios.post("/self/company/employees", {
        email,
        full_name,
        employee_role,
      })
      return result
    } catch (e) {
      throw e
    }
  },

  getEmployees: async () => {
    try {
      const result = await axios.get("/self/company/team")
      return result
    } catch (e) {
      console.log(e)
    }
  },

  deleteEmployee: async (uuid) => {
    try {
      axios.delete(`/employees/${uuid}`)
    } catch (e) {
      console.log(e)
    }
  },

  setPassword: async (password, token, reason = null) => {
    try {
      const payload = {
        reset_password_token: token,
      }
      // Only include password if it's provided (not for password change confirmation)
      if (password) {
        payload.password = password
      }
      
      const result = await axios.post(`/reset_password`, payload)
      if (result.status === 200 && result.data.access_token) {
        axios.defaults.headers[
          "Authorization"
        ] = `Bearer ${result.data.access_token}`
        save("accessToken", result.data.access_token)
      }
      return result
    } catch (e) {
      // Re-throw the error so the calling code can handle it
      throw e
    }
  },
  checkToken: async (token) => {
    try {
      const result = await axios.get(
        `/token_status?reset_password_token=${token}`,
      )

      return result
    } catch (e) {
      throw e
    }
  },
}
